import { ToastType } from 'react-toastify';

import { API_SAVE_INTEGRATION_URL } from './facebook-integration.constants';

import { handleToastByActionType } from '../../../shared/utils/toast-redux';
import { getApiErrorKeyByException } from '../../../shared/api/api.utils';

export const FACEBOOK_INTEGRATION_OPENED = '@integrations/facebook/INTEGRATION_OPENED';
export const FACEBOOK_INTEGRATION_CLOSED = '@integrations/facebook/INTEGRATION_CLOSED';
export const FACEBOOK_INTEGRATION_SAVE_TOKEN = '@integrations/facebook/SAVE_TOKEN_REQUEST_CALLED';
export const FACEBOOK_INTEGRATION_SAVE_TOKEN_SUCCESS = '@integrations/facebook/SAVE_TOKEN_REQUEST_SUCCESS';
export const FACEBOOK_INTEGRATION_SAVE_TOKEN_START = '@integrations/facebook/SAVE_TOKEN_REQUEST_START';
export const FACEBOOK_INTEGRATION_SAVE_TOKEN_FAIL = '@integrations/facebook/SAVE_TOKEN_REQUEST_FAIL';
export const FACEBOOK_INTEGRATION_SAVE_TOKEN_FINISH = '@integrations/facebook/SAVE_TOKEN_REQUEST_FINISH';

const handleResponseFeedback = handleToastByActionType({
    [FACEBOOK_INTEGRATION_SAVE_TOKEN_FAIL]: action => ({
        message: getApiErrorKeyByException(action.payload),
        toastType: ToastType.ERROR,
        toastId: 'fb-integration-fail',
    }),
});

export const saveFacebookIntegration = (token: string) => ({
    type: FACEBOOK_INTEGRATION_SAVE_TOKEN,
    actionTypes: {
        start: FACEBOOK_INTEGRATION_SAVE_TOKEN_START,
        fail: FACEBOOK_INTEGRATION_SAVE_TOKEN_FAIL,
        success: FACEBOOK_INTEGRATION_SAVE_TOKEN_SUCCESS,
        finish: FACEBOOK_INTEGRATION_SAVE_TOKEN_FINISH,
    },
    config: {
        url: API_SAVE_INTEGRATION_URL,
        method: 'POST',
        data: { facebook_access_token: token },
    },
    meta: {
        onAxiosFinally: handleResponseFeedback,
    },
});

export const openFacebookIntegration = () => ({
    type: FACEBOOK_INTEGRATION_OPENED,
});

export const closeFacebookIntegration = () => ({
    type: FACEBOOK_INTEGRATION_CLOSED,
});
